<style>
    .header {
      background-color: black;
      color: white;
      padding: 1rem 0;
    }
    .title {
      font-family: "dos", sans-serif;
      color: white;
      margin: 0;
    }
    .header .container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  </style>
  
  
  <header class="header">
    <div class="container is-fluid">
<h1 class="title">PolitoGroupsBot</h1>
    </div>
  </header>
  